module.exports = __webpack_public_path__ + "static/img/3.750173f9.png";